export const WIZARD_TYPES: { [key: string]: string } = {
  default: 'default-wizard',
  header: 'header-wizard',
};

export const WIZARD_PARAMS = {
  openDomain: 'opendomain',
  default: 'default',
};

export const WIZARD_PARAMS_KEYS = {
  userFrom: 'userfrom',
};

export const WIZARD_COMPONENT = {
  wizardCheckbox: 'wizard-checkbox',
  wizardFaqItem: 'wizard-faq-item',
  resultContainer: 'wizard-results-container',
  wizardCard: 'wizard-card',
};

export const WIZARD_RESULT = {
  maxProducts: 3,
  maxArticles: 3,
};

export const WIZARD_TAILORED_RESULT = {
  maxProducts: 9,
  maxArticles: 9,
};

export const WIZARD_SLUG = {
  conversation: 'breedtegesprek',
  intake: 'productwijzer',
};

export const WIZARD_NAME = {
  cyberWizard: 'Cyberrisicoscan',
  intakeWizard: 'Productwijzer',
  youlend: 'YouLend',
  cyberScan: 'Cyberscan',
  applyForFinancing: 'Financiering aanvragen',
  applyForFinancingInPage: 'Financieren - Wizard',
  nlgroeit: 'nlgroeit - mentorschap aanvragen',
  ambitiegesprek: 'Begin met vooruitdenken',
  tikkieCheck: 'Afrekenen met Tikkie',
};

export const WIZARD_ID = {
  oldCyberWizard: '28c2f117-a07b-5d5d-86c1-95b83aea74df',
  oldIntakeWizard: '209433af-ded0-5a90-906f-8d9b8d9ed251',
  tikkieCheck: 'ba2cd21a-d19f-58bc-8559-630537891afd',
  customContentWizardHeader: '465d7f44-b94c-53d1-982f-213dd206fcc6',
  notarissenAccountants: '2bb60541-89cf-55f0-8548-6bdc0493c973',
};

export const WIZARD_CARDS_ELEVATION: { [key: string]: 'low' | 'high' } = {
  low: 'low',
  high: 'high',
};

export const STEP_TYPES = {
  default: 'default',
  header: 'header',
};

export const WIZARD_CARD_TYPES = {
  card: 'card',
  transparent: 'transparent',
};

export const WIZARD_RESULT_CARD_TYPES = {
  articleSplitImage: 'split-image',
  articleFullImage: 'full-image',
  previewCard: 'preview-card',
  gatedDownloadCard: 'gated-download-card',
};
